/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from 'react';
import { validateEmail } from '../../../../CommonMethods/EmailValidator';
import ErrorMessage from '../../../../components/ErrorMessage';
import GlobalContext from '../../../../components/Context/GloablContext';
import Loader from '../../../../components/Loader';
import { motion } from 'framer-motion';
import BannerImage from '../../../../components/BannerImage';
import AnimatedPage from '../../../../components/Animation/AnimatedPage';
import { dataService } from '../../../../services/data.services';
import { useDispatch } from 'react-redux';
import { handleSidebarAnimation } from '../../../../redux/commonSlice';
import { usersList } from '../../../../features/apiSlice';
import HelpGuideModal from '../../../../components/HelpGuideModal/index';
import { LOGOUT_MESSAGES } from '../../../../CommonMethods/authSession';

export default function SignIn({
    isSubmitSelected,
    setIsSubmitSelected,
    setIsLoginPage,
    handleLoginCredentilas,
    emptyError,
    setEmptyError,
    email,
    password,
    error,
    seterror,
    handleLogin,
    loading,
    loginError,
    setIsForgotPassword,
}) {
    const [type, settype] = useState(true);
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [invalidPassword, setInvalidPassword] = useState(false);
    const { setToastmessage, setToastErrorMessage, editSocket, setEditSocket,handleOnClickClearSearch } = useContext(GlobalContext);
    const dispatch = useDispatch();
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const helguidedata = '/images/admin-login.png'
    
    // Handle email change and validation
    function handleEmailChange(enteredEmail) {
        setInvalidEmail(!validateEmail(enteredEmail)); // Validate email input
    }

    // Toggle password visibility
    const handleShowPassword = () => {
        settype(!type);
    };

    // useEffect to handle various checks on component mount
    useEffect(() => {
        const status = localStorage.getItem('custom-status');

        if (status === 'inactive' && status !== undefined) {
            setToastErrorMessage(LOGOUT_MESSAGES.expired);
        }
        sessionStorage.clear();
        dispatch(handleSidebarAnimation(true));
        dispatch(usersList.util.resetApiState());

        const arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token');
        const logoutfromallTabs = localStorage.getItem('LogoutfromAllTabs');
        if (localStorage.getItem('AccessToken')) {
            localStorage.setItem('LogoutfromAllTabs', logoutfromallTabs);
            localStorage.setItem('arcm_trust_browser_token', arcm_trust_browser_token);
        }
        localStorage.removeItem('custom-status')

        if (editSocket && (editSocket.readyState === 1 || editSocket.readyState === 0)) {
            editSocket.close();
            editSocket.onclose = (event) => {
                console.log('WebSocket closed successfully:', event);
            };
            editSocket.onerror = (error) => {
                console.error('WebSocket encountered an error during closing:', error);
            };
            setTimeout(() => {
                console.log('WebSocket state after close:', editSocket.readyState);
            }, 1000);
        }

        if (localStorage.getItem('showLogoutToast')) {
            setToastErrorMessage('You have been logged out due to another login session');
            localStorage.removeItem('showLogoutToast');
        }
    }, []);

    return (
        <>
            <AnimatedPage>
                <div className='w-[35%] 2xl:w-[30%] pl-[30px] 2xl:pl-0'>
                    <div className='w-[290px] xl:[300px] 2xl:w-[330px] flex flex-col justify-center items-center h-screen'>
                        <div className='w-full'>
                            <img
                                src='/images/Arcm_login_logo.png'
                                alt='Banner-Img'
                                className='w-[233px] h-fit mx-auto'
                                loading='lazy'
                                decoding='async'
                            />
                            <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>Login</h1>
                            <div className='flex justify-center items-center'>
                                <h1 className='text-lg font-normal text-[#000] text-center'>Please enter your details to login</h1>
                                
                                <span onClick={()=>{setHelpGuideModel(true)}} className='ml-0.5 cursor-pointer'>
                                    <img src='/images/info.png' alt='icon' loading='lazy' decoding='async' />
                                </span>
                            </div>
                            <form action='' className='mt-8' onSubmit={(e) => handleLogin(e)}>
                                <div className='flex flex-col'>
                                    <label htmlFor='email' className='text-xs font-semibold text-[#000] pb-1.5'>
                                        Username
                                    </label>
                                    <input
                                        type='text'
                                        id='userName'
                                        value={email}
                                        onChange={(e) => {
                                            setIsSubmitSelected(false);
                                            handleLoginCredentilas('email', e.target.value);
                                            handleEmailChange(e.target.value);
                                        }}
                                        onFocus={() => {
                                            seterror(false);
                                            setToastErrorMessage('');
                                            setInvalidEmail(false);
                                            setEmptyError(false);
                                        }}
                                        maxLength={80}
                                        style={{
                                            border: `1px solid ${error || (emptyError && email.trim() === '') ? '#C81720' : '#C5C9DA'}`,
                                        }}
                                        className='border border-[#C5C9DA] rounded-lg px-3.5 py-[11px] text-sm font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none focus:border-[#339D9E] focus:shadow-s1'
                                        placeholder='Enter username'
                                    />
                                </div>
                                <div className='flex flex-col mt-4'>
                                    <label htmlFor='Username' className='text-xs font-semibold text-[#000] pb-1.5'>
                                        Password
                                    </label>
                                    <div className='relative'>
                                        <input
                                            type={type ? 'password' : 'text'}
                                            id='passWord'
                                            value={password}
                                            onFocus={() => {
                                                setIsSubmitSelected(false);
                                                seterror(false);
                                                setToastErrorMessage('');
                                                setInvalidPassword(false);
                                                setEmptyError(false);
                                            }}
                                            maxLength={80}
                                            style={{
                                                border: `1px solid ${error || invalidPassword || (emptyError && password.trim() === '') ? '#C81720' : '#C5C9DA'}`,
                                            }}
                                            onChange={(e) => {
                                                handleLoginCredentilas('password', e.target.value);
                                            }}
                                            className='border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none focus:border-[#339D9E] focus:shadow-s1'
                                            autoComplete='off'
                                            placeholder='Enter password'
                                        />
                                        <button type='button' className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                            <span onClick={() => handleShowPassword()} className='text-xs font-semibold text-[#008586]'>
                                                {type ? 'SHOW' : 'HIDE'}
                                            </span>
                                        </button>
                                    </div>
                                </div>
                                {error && <ErrorMessage error message={loginError} />}
                                <button type='button' disabled={loading} onClick={() => setIsForgotPassword(true)} id='forgot' className='text-xs font-semibold text-[#008586] mt-3'>
                                    Forgot password
                                </button>
                                <button
                                    type='submit'
                                    id='login'
                                    disabled={loading}
                                    className='w-full mt-8 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]'
                                >
                                    {!loading ? 'Login' : <Loader />}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </AnimatedPage>
            {/* Conditionally render Help Guide Modal */}
            {helpGuideModel && (
                <HelpGuideModal pdfUrl={helguidedata} setHelpGuideModel={setHelpGuideModel} />   
            )}
        </>
    );
}
